(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
